export default "__VITE_ASSET__DssuPGZv__"